import type { GasPurePayload } from '@atlaskit/analytics-gas-types';
import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';

import type {
	CrossJoinIntegration,
	CrossJoinSourceProduct,
	CrossJoinTargetProduct,
} from '../../common/types';
import type { AccessRequestResponse, AccessRequestType } from '../types';

export const requestAccess = async (
	product: CrossJoinTargetProduct,
	sourceProduct: CrossJoinSourceProduct,
	integration: CrossJoinIntegration,
	userId: string,
	cloudId: string,
	createAnalyticsEvent: CreateUIAnalyticsEvent,
): Promise<AccessRequestType> => {
	const resource = `ari:cloud:${product}::site/${cloudId}`;
	try {
		const response = await fetch('/gateway/api/invitations/v1/access-requests/request', {
			method: 'POST',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				resource,
				metadata: {
					touchpoint: 'Crossjoin Nudge',
					sourceProduct,
				},
			}),
		});

		const accessRequestResponse = (await response.json()) as unknown as AccessRequestResponse;
		const { results } = accessRequestResponse;
		const result = results[resource];
		const analyticsAttributes = {
			userId,
			products: [product],
			inviteResult: [
				{
					resourceAri: resource,
					status: result,
				},
			],
			integration,
		};

		createAnalyticsEvent({
			type: 'sendTrackEvent',
			data: {
				action: 'requested',
				actionSubject: 'productAccess',
				source: integration,
				attributes: analyticsAttributes,
			} satisfies GasPurePayload,
		}).fire();
		return result;
	} catch (error) {
		createAnalyticsEvent({
			type: 'sendOperationalEvent',
			data: {
				action: 'failed',
				actionSubject: 'requestAccess',
				source: integration,
				attributes: {
					message: String(error),
					details: { ...(error || {}) },
				},
			} satisfies GasPurePayload,
		}).fire();
		throw error;
	}
};
